module.exports = __webpack_public_path__ + "static/media/CollapseUp.e505557c.svg";